import { render, staticRenderFns } from "./PageNotAllowed.vue?vue&type=template&id=253a0c22&scoped=true"
import script from "./PageNotAllowed.vue?vue&type=script&lang=js"
export * from "./PageNotAllowed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253a0c22",
  null
  
)

export default component.exports